import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AppConfigService } from "src/app/services/app-config.service";
import {  TipoProvvedimento } from '../models';


class DataTablesResponse {
    data: TipoProvvedimento[];
    draw: number;
    recordsFiltered: number;
    recordsTotal: number;
}

@Injectable({
    providedIn: "root"
})
export class TipoProvvedimentoService {
    private apiUrl = `${AppConfigService.env.api_endpoint}${AppConfigService.env.endpoints.inframob}TipiProvvedimento/`;
    constructor(private http: HttpClient) { }

    getAllDt(dataTablesParameters: any) {
        return this.http.post<DataTablesResponse>(
            `${this.apiUrl}alldt`,
            dataTablesParameters
        );
    }
    getAll() {
        return this.http.get<TipoProvvedimento[]>(
            `${this.apiUrl}`
        );
    }
    insert(s: TipoProvvedimento) {
        return this.http.post<any>(`${this.apiUrl}`, s);
    }
    update(s: TipoProvvedimento) {
        return this.http.put<any>(`${this.apiUrl}${s.id}`, s);
    }
    delete(id: number) {
        return this.http.delete<any>(`${this.apiUrl}${id}`);
    }
    save(s:TipoProvvedimento){
        if (s.id) return this.update(s);
        return this.insert(s);
    }

}
